export default "__VITE_ASSET__DdCZaRrR__"